<template>
    <a-modal
        :visible="visible"
        :title="`${state.title} - Kelola Pengguna`"
        @ok="ConversionPoint"
        @cancel="handleModalCancel"
        width="60%"
        :destroy-on-close="true"
        :footer="null">
    
        <AForm
            ref="formRef"
            class="myform"
            :model="form"
            :rules="state.rules"
            @keydown="form.onKeydown($event)"
            @finish="handleOk"
            :wrapper-col="{ span: 14 }"
            :scroll-to-first-error="true">

            <!-- no pegawai -->
            <a-row class="form-row">
                <a-col :sm="24">
                    <a-form-item
                        label="No Pegawai"
                        :label-col="{ sm: { span: 4 } }"
                        :wrapper-col="{ sm: { span: 24 - 4 } }"
                        name="nopeg"
                        has-feedback>
                        <AInput
                            placeholder="no pegawai"
                            :disabled="item.readOnly"
                            v-model:value="form.nopeg" />
                    </a-form-item>
                </a-col>
            </a-row>

            <!-- nama pegawai -->
            <a-row class="form-row">
                <a-col :sm="24">
                    <a-form-item
                        label="Nama Pengguna"
                        :label-col="{ sm: { span: 4 } }"
                        :wrapper-col="{ sm: { span: 24 - 4 } }"
                        required
                        name="fullname"
                        has-feedback>
                        <AInput
                            placeholder="nama pengguna"
                            :disabled="item.readOnly"
                            v-model:value="form.fullname" />
                    </a-form-item>
                </a-col>
            </a-row>

            <!-- email -->
            <a-row class="form-row">
                <a-col :sm="24">
                    <a-form-item
                        label="Email"
                        :label-col="{ sm: { span: 4 } }"
                        :wrapper-col="{ sm: { span: 24 - 4 } }"
                        required
                        name="email"
                        has-feedback>
                        <AInput
                            placeholder="nama@domain.com"
                            :disabled="item.readOnly"
                            v-model:value="form.email" />
                    </a-form-item>
                </a-col>
            </a-row>

            <!-- kata sandi -->
            <a-row v-if="!form.id" class="form-row">
                <a-col :sm="24">
                    <a-form-item
                        label="Kata Sandi"
                        :label-col="{ sm: { span: 4 } }"
                        :wrapper-col="{ sm: { span: 24 - 4 } }"
                        required
                        name="password"
                        has-feedback>
                        <AInputPassword
                            placeholder="kata sandi"
                            :disabled="item.readOnly"
                            v-model:value="form.password" />
                    </a-form-item>
                </a-col>
            </a-row>

            <!-- konfirmasi kata sandi -->
            <a-row v-if="!form.id" class="form-row">
                <a-col :sm="24">
                    <a-form-item
                        label="Konfirmasi Kata Sandi"
                        :label-col="{ sm: { span: 4 } }"
                        :wrapper-col="{ sm: { span: 24 - 4 } }"
                        required
                        name="retype_password"
                        has-feedback>
                        <AInputPassword
                            placeholder="konfirmasi kata sandi"
                            :disabled="item.readOnly"
                            v-model:value="form.retype_password" />
                    </a-form-item>
                </a-col>
            </a-row>

            <!-- phone -->
            <a-row class="form-row">
                <a-col :sm="24">
                    <a-form-item
                        label="Nomor Telepon"
                        :label-col="{ sm: { span: 4 } }"
                        :wrapper-col="{ sm: { span: 24 - 4 } }"
                        required
                        name="phone"
                        has-feedback>
                        <AInput
                            addon-before="+62"
                            onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                            pattern="^[1-9][0-9]*$"
                            oninput="if(!this.value.match('^[1-9][0-9]*$'))this.value='';"
                            placeholder="Ex : 81xxxxxxxxx"
                            v-model:value="form.phone"
                            :disabled="item.readOnly"
                            min="0"
                            maxlength="13" />
                    </a-form-item>
                </a-col>
            </a-row>

            <!-- role -->
            <ARow class="form-row">
                <ACol :md="12" :sm="24">
                    <AFormItem
                        label="Role"
                        :label-col="{ sm: { span: 8 } }"
                        :wrapper-col="{ sm: { span: 24 - 8 } }"
                        required
                        name="role_id"
                        has-feedback>
                        <FilterRole
                            style="width:100%"
                            :disabled="item.readOnly"
                            v-model:value="form.role_id"
                            show-search
                            :mode="null"
                            @change="onRoleChange"/>
                    </AFormItem>
                </ACol>
                <ACol :md="12" :sm="24" v-if="includes([1, 1259963, 1259979], form.role_id)">
                    <AFormItem
                        label=""
                        :label-col="{ sm: { span: 0 } }"
                        :wrapper-col="{ sm: { span: 24 } }"
                        required
                        name="vendor_id"
                        has-feedback>
                        <FilterDistributorAll
                            v-if="form.role_id == 1"
                            style="width:100%"
                            :disabled="item.readOnly"
                            v-model:value="form.vendor_id"
                            show-search
                            :mode="null"
                            :join-options="form.vendor_id ? [{ id: form.vendor_id, name: `${item.vendor_code} - ${item.vendor_name}` }] : []" />
                        <FilterDistributor
                            v-else
                            style="width:100%"
                            :disabled="item.readOnly"
                            v-model:value="form.vendor_id"
                            show-search
                            :mode="null"
                            :join-options="form.vendor_id ? [{ id: form.vendor_id, name: `${item.vendor_code} - ${item.vendor_name}` }] : []" />
                    </AFormItem>
                </ACol>
            </ARow>

            <!-- group mapping -->
            <a-row class="form-row">
                <a-col :md="12" :sm="24">
                    <a-form-item
                        label="Group Mapping"
                        :label-col="{ sm: { span: 8 } }"
                        :wrapper-col="{ sm: { span: 24 - 8 } }"
                        required
                        name="group_role_id"
                        has-feedback>
                        <FilterGroupRole
                            :mode="null"
                            v-model:value="form.group_role_id"
                            v-model:role="form.role_id"
                            :display-label="form.group_area_name"
                            :disabled="item.readOnly"
                            style="width:100%"
                            @change="onGroupMappingChange"/>
                    </a-form-item>
                </a-col>
                <a-col :md="12" :sm="24" v-if="includes([55414, 55407], form.role_id)">
                    <a-form-item
                        label=""
                        name="distributor_id"
                        :label-col="{ sm: { span: 0 } }"
                        :wrapper-col="{ sm: { span: 24 } }"
                        has-feedback>
                        <FilterDistributorByArea
                            v-model:value="form.distributor_id"
                            v-model:group_role_id="form.group_role_id"
                            :disabled="item.readOnly"
                            style="width:100%"
                            :rules="[{ 
                                required: true, 
                                message: 'Distributor tidak boleh kosong!',
                            }]"
                            @change="onDistributorChange"
                        />
                    </a-form-item>
                </a-col>
            </a-row>

            <ARow class="form-row" v-if="includes([55414, 55407], form.role_id)">
                <ACol :span="24">
                    <AFormItem
                    label="Area"
                    :label-col="{ sm: { span: 4 } }"
                    :wrapper-col="{ sm: { span: 20 } }">
                    <ARow gutter="16">
                        <ACol
                            v-for="(distributorId, index) in form.distributor_id"
                            :key="distributorId"
                            :md="12" :sm="24">
                            <div class="distributor-card">
                                <div class="distributor-label" style="font-size:12px; margin-bottom: -12px;">
                                    {{ form.distributor_labels[distributorId] || distributorId }}
                                </div>
                                <AFormItem
                                    :name="['area', distributorId]"
                                    :label-col="{ span: 24 }"
                                    :wrapper-col="{ span: 24 }"
                                    :rules="[{ 
                                        required: true, 
                                        message: 'Area tidak boleh kosong!',
                                    }]"
                                    style="margin-bottom:0">
                                    <FilterAreaByGroupRole
                                        v-model:value="form.area[distributorId]"
                                        v-model:items="form.areas[index]"
                                        :group_role="form.group_role_id"
                                        :disabled="item.readOnly"
                                        style="width:100%"
                                    />
                                </AFormItem>
                            </div>
                        </ACol>
                    </ARow>
                    <p v-if="!form.distributor_id.length" class="empty-text">Area akan tampil setelah pilih distributor.</p>
                    </AFormItem>
                </ACol>
            </ARow>

            <!-- kabupaten kota -->
            <!-- <a-row
                v-if="form.role_id == 55414"
                class="form-row">
                <a-col :sm="24">
                    <a-form-item
                        label="Kabupaten/Kota"
                        :label-col="{ sm: { span: 4 } }"
                        :wrapper-col="{ sm: { span: 24 - 4 } }"
                        required
                        name="kabupaten"
                        has-feedback>
                        <FilterKabupatenGroupRole
                            v-model:value="form.kabupaten"
                            v-model:role="form.role_id"
                            v-model:group_role_id="form.group_role_id"
                            :disabled="item.readOnly"
                            style="width:100%"/>
                    </a-form-item>
                </a-col>
            </a-row> -->

            <a-row class="form-row">
                <a-col :sm="24">
                    <AFormItem
                        label="Status"
                        :label-col="{ sm: { span: 4 } }"
                        :wrapper-col="{ sm: { span: 24 - 4 } }"
                        required
                        name="active"
                        has-feedback>
                        <ARadioGroup
                            v-model:value="form.active"
                            :disabled="item.readOnly"
                            style="width:100%">
                            <a-radio :value="true">Aktif</a-radio>
                            <a-radio :value="false">Non Aktif</a-radio>
                        </ARadioGroup>
                    </AFormItem>
                </a-col>
            </a-row>

            <a-row v-if="!item.readOnly" class="form-row" type="flex" justify="end">
                <a-col>
                    <a-form-item>
                        <a-button
                            type="primary"
                            html-type="submit"
                            :loading="form.busy"
                            :disabled="form.busy">{{
                            !form.id ? 'Simpan' : 'Perbarui'
                        }}</a-button>
                    </a-form-item>
                </a-col>
            </a-row>
        </AForm>

        <div v-if="form.errors.any()">
            <ASpace>
                <AAlert
                    v-for="(item, index) in form.errors.all()"
                    type="error"
                    :key="index"
                    :message="item.message"
                    banner
                    closable
                    @close="form.clear()" />
            </ASpace>
        </div>
    </a-modal>
</template>
<script>
import {
    defineComponent,
    onMounted,
    reactive,
    watch,
    ref,
} from 'vue'
import Form from 'vform'
import apiClient from '@/services/axios'
import { Modal, message } from 'ant-design-vue'
import FilterDistributorAll from '@/components/filter/FilterDistributorAll'
import FilterDistributor from '@/components/filter/FilterDistributor'
import FilterRole from '@/components/filter/FilterRole'
import FilterGroupRole from '@/components/filter/FilterGroupRole'
import FilterAreaByGroupRole from '@/components/filter/FilterAreaByGroupRole'
// import FilterKabupatenGroupRole from '@/components/filter/FilterKabupatenGroupRole'
import FilterDistributorByArea from '@/components/filter/FilterDistributorByArea'
import { includes } from 'lodash'

export default defineComponent({
    components: {
        FilterDistributorAll,
        FilterDistributor,
        FilterRole,
        FilterGroupRole,
        FilterAreaByGroupRole,
        // FilterKabupatenGroupRole,
        FilterDistributorByArea,
    },
    props: {
        visible: [Boolean],
        item: {
            type: Object,
            default: () => ({
                id: null,
                readOnly: false,
            }),
        },
    },
    emits: ['handleOkConversionPoint', 'update:visible', 'success'],
    setup(props, { emit }) {
        const form = reactive(new Form({
            id: props.item.id,
            nopeg: null,
            fullname: null,
            email: null,
            password: null,
            retype_password: null,
            phone: null,
            active: null,
            role_id: [],
            group_role_id: [],
            area: [],
            areas: [],
            kabupaten: [],
            distributor_id: [], 
            distributor_labels: {},
            vendor_id: [],
            // optional
            role_name: '',
            group_area_name: '',
            readOnly: false,
        }))

        const formRef = ref();

        const state = reactive({
            title: 'Lihat',
            data: [],
            page: 1,
            per_page: 1,
            total: 0,
            loading: false,
            rules: {
                fullname: [
                    {
                        required: true,
                        message: "Nama pegawai tidak boleh kosong!",
                    },
                ],
                email: [
                    {
                        required: true,
                        message: "Email tidak boleh kosong!",
                    },
                ],
                password: [
                    {
                        required: true,
                        message: "Kata sandi tidak boleh kosong!",
                    },
                    {
                        min: 8,
                        message: 'Kata Sandi minimal 8 karakter!',
                    },
                ],
                retype_password: [
                    {
                        required: true,
                        message: "Konfirmasi kata sandi tidak boleh kosong!",
                    },
                    {
                        validator: async (rule, value) => {
                            if (value !== form.password) {
                                return Promise.reject('Konfirmasi kata sandi harus sama dengan kata sandi!')
                            } else {
                                return Promise.resolve()
                            }
                        },
                    },
                ],
                phone: [
                    {
                        required: true,
                        message: 'Nomor Telepon tidak boleh kosong!',
                    },
                    {
                        max: 12,
                        min: 0,
                        message: 'Maximal nomor telepon 12 angka',
                    },
                    {
                        pattern: /^[0-9]*$/,
                        message: 'Nomor Telepon tidak boleh memuat karakter selain angka',
                    },
                ],
                role_id: [
                    {
                        required: true,
                        type: 'number',
                        message: 'Role tidak boleh kosong!',
                    },
                ],
                vendor_id: [
                    {
                        required: true,
                        message: 'Distributor tidak boleh kosong!',
                    },
                ],
                kabupaten: [
                    {
                        required: true,
                        message: 'Kabupaten tidak boleh kosong!',
                    },
                ],
                group_role_id: [
                    {
                        required: true,
                        type: 'number',
                        message: 'Group Mapping tidak boleh kosong!',
                    },
                ],
                active: [
                    {
                        required: true,
                        message: "Status tidak boleh kosong!",
                    },
                ],
            },
        })

        const onRoleChange = () => {
            form.group_role_id = []
            form.distributor_id = []
        }

        const onGroupMappingChange = () => {
            form.distributor_id = []
            form.area = {} 
            form.areas = []
        }

        const handleModalCancel = () => {
            emit('update:visible', false)
            emit('update:item', null)
        }

        const handleOk = async () => {
            // validation form
            await formRef.value.validate().catch(() => {});

            form.distributor_area = buildDistributorArea()

            if (!form.id) {
                form.post('/api/users')
                    .then(({ data }) => {
                        if (data === undefined) {
                            errorMessage.value = `Kode error 500, No response from server`
                            return
                        }

                        message.success('Berhasil menyimpan')

                        syncRoleUser(form, data.id)

                        emit('success', data)
                        handleModalCancel()
                    })
            } else {
                delete form.password
                delete form.retype_password

                form.put(`/api/users/${form.id}`)
                    .then(({ data }) => {
                        if (data === undefined) {
                            errorMessage.value = `Kode error 500, No response from server`
                            return
                        }

                        message.success('Berhasil memperbarui')

                        syncRoleUser(form, form.id)

                        handleModalCancel()
                        emit('success', data)
                    })
            }

        }

        const buildDistributorArea = () => {
            const result = []

            if (!Array.isArray(form.distributor_id)) return result

            form.distributor_id.forEach((distributorId) => {
                const areas = form.area?.[distributorId]

                if (!areas) return

                const areaList = Array.isArray(areas) ? areas : [areas]

                areaList.forEach((areaId) => {
                    result.push({
                        distributor_id: String(distributorId),
                        area_id: String(areaId),
                    })
                })
            })

            return result
        }

        const syncRoleUser = (payload, userId = null) => {
            apiClient
                .post('/api/users/' + (payload.id || userId) + '/assign', payload)
                .then(({ data }) => {
                    if (!userId) {
                        message.success('Berhasil simpan!')
                    }
                })
                .catch(e => {
                    message.error(userId ? 'Gagal Update Role!' : 'Berhasil simpan tapi gagal menunjuk role, silahkan mengedit data baru tersebut!')
                })
        }

        const onDistributorChange = (value, option) => {
            if (!form.distributor_labels) {
                form.distributor_labels = {}
            }
            // multiple select
            if (Array.isArray(option)) {
                option.forEach(opt => {
                    form.distributor_labels[opt.value] = opt.label
                })
            } 
            // single select
            else if (option) {
                form.distributor_labels[option.value] = option.label
            }
        }

        watch(
            () => form.distributor_id,
            (val) => {
                const newArea = { ...form.area }

                val.forEach(distributorId => {
                    if (!newArea[distributorId]) {
                        newArea[distributorId] = []
                    }
                })

                form.area = newArea
                form.areas = val.map(() => [])
            },
        )

        // handle func vue
        onMounted(() => {
            if (!form.id) {
                form.reset()
            } else {
                form.nopeg = props.item.nopeg
                form.fullname = props.item.fullname
                form.email = props.item.email
                form.phone = props.item.phone
                form.active = props.item.active
                form.role_id = props.item.role_id
                form.vendor_id = props.item.vendor_id
                form.group_role_id = props.item.group_role_id
                form.kabupaten = props.item.kabupaten != null ? props.item.kabupaten.map(item => item.id) : []
                // form.distributor_id = props.item.distributor_area ? props.item.distributor_area.map(item => item.id) : []
                // Mapping distributor_area ke form.area
                if (props.item.distributor_area) {
                    const map = {}
                    props.item.distributor_area.forEach((item) => {
                        if (!map[item.id]) {
                            map[item.id] = {
                                areas: [],
                                label: item.name,
                            }
                        }
                        map[item.id].areas.push(item.area)
                    })
                    // distributor_id unik
                    form.distributor_id = Object.keys(map).map(id => Number(id))
                    // set area & label
                    form.distributor_id.forEach(id => {
                        form.area[id] = map[id].areas
                        form.distributor_labels[id] = map[id].label
                    })
                }
                // optional name text
                form.role_name = props.item.role_name
                form.group_area_name = props.item.group_area
            }

            if (!props.item.readOnly) {
                state.title = !form.id ? 'Tambah' : 'Edit'
            }
        })

        return {
            formRef,
            handleOk,
            form,
            state,
            handleModalCancel,
            onRoleChange,
            onGroupMappingChange,
            onDistributorChange,
            // lodash
            includes,
        }
    },
})
</script>

<style lang="scss" scoped>
@import '@/assets/scss/form.scss';
</style>
